/**
 * Frontend permissions utility
 * Mirrors backend permission logic for role impersonation
 */

import { UserRole, Permission } from '../api/client';

/**
 * Permission to roles mapping (mirrors backend)
 */
const permissionRoles: Record<Permission, UserRole[]> = {
  'dashboard:view': ['viewer', 'asst', 'sales', 'exec', 'sales_manager'],
  'dashboard:edit': ['sales', 'sales_manager'],
  'leads:view': ['viewer', 'asst', 'sales', 'exec', 'sales_manager'],
  'leads:view_assignments': ['asst', 'sales', 'exec', 'sales_manager'],
  'leads:claim': ['sales', 'sales_manager'],
  'leads:update_status': ['sales', 'sales_manager'],
  'leads:assign': ['sales_manager'],
  'leads:approve_request': ['sales_manager'],
  'leads:return_to_pool': ['sales_manager'],
  'sources:view': ['asst', 'sales', 'sales_manager'],
  'sources:fetch': ['sales', 'sales_manager'],
  'admin:impersonate': [],
  'admin:manage_users': [],
  'automation:view': ['sales_manager'],
  'automation:configure': [],
};

/**
 * Check if a role has a specific permission
 */
export function hasPermission(role: UserRole, permission: Permission): boolean {
  if (role === 'unauthorized') {
    return false;
  }
  if (role === 'superadmin') {
    return true;
  }
  const allowedRoles = permissionRoles[permission];
  return allowedRoles?.includes(role) ?? false;
}

/**
 * Get all permissions for a given role
 */
export function getPermissionsForRole(role: UserRole): Record<Permission, boolean> {
  const permissions = {} as Record<Permission, boolean>;
  for (const permission of Object.keys(permissionRoles) as Permission[]) {
    permissions[permission] = hasPermission(role, permission);
  }
  return permissions;
}
